import {findFullName} from './custom-utils'

/**
 * Handles setting the selected country, region, and language preferences in localStorage
 * and updates the state with the selected values.
 *
 * @param {Object} params
 * @param {Object} params.locale - The locale object containing the locale ID.
 * @param {Array} params.countries - List of country options.
 * @param {Array} params.languages - List of language options.
 * @param {Function} params.findFullName - Function to find full name from a country/language code.
 * @param {Function} params.setCountryRegionsAndLanguage - Setter function to update state with selected values.
 */
export const handleCountryRegionLanguage = ({
    locale,
    regions,
    countries,
    languages,
    findFullName,
    setCountryRegionsAndLanguage
}) => {
    const [localeID, countryID] = locale?.id.split('-') || []

    const region = regions.find((region) =>
        region?.countries?.some((country) => country?.value === countryID)
    ) || {value: 'US', label: 'North America'}

    const selectedCountryRegionLanguage = {
        flagIcon: countryID,
        country: {
            value: countryID,
            label: findFullName(countryID, countries)
        },
        language: {
            value: localeID,
            label: findFullName(localeID, languages)
        },
        region: {
            value: region.value,
            label: region.label
        }
    }

    localStorage.setItem(
        'selectedCountryRegionLanguage',
        JSON.stringify(selectedCountryRegionLanguage)
    )
    setCountryRegionsAndLanguage(selectedCountryRegionLanguage)
}

export const redirectSFRA = (getConfig, values) => {
    const config = getConfig()
    const sfccOrigin = `https://${config.ssrParameters.proxyConfigs[1].host}`
    const newURL =
        sfccOrigin +
        '/s/CrunchyrollEU' +
        '/' +
        values.country.toLowerCase() +
        '/' +
        values?.language.toLowerCase()
    window.location.href = newURL
}

export const updateSitewithLocale = (
    regions,
    countries,
    languages,
    values,
    setCountryFlag,
    closeModal
) => {
    const pathname =
        values.region?.toLowerCase() === 'us'
            ? '/'
            : values.region?.toLowerCase() === 'eu'
            ? `/${values.region?.toLowerCase()}/${values.country?.toLowerCase()}/${values.language?.toLowerCase()}/`
            : `/${values.region?.toLowerCase()}/`
    const updatedOrigin = window?.location?.origin + pathname
    const newURL = new URL(updatedOrigin)
    newURL.pathname = pathname

    setCountryFlag(values.country?.toUpperCase())

    localStorage.setItem(
        'selectedCountryRegionLanguage',
        JSON.stringify({
            region: {
                value: values.region || 'US',
                label: findFullName(values.region, regions) || 'North America'
            },
            country: {
                value: values.country || 'US',
                label: findFullName(values.country, countries) || 'United States'
            },
            language: {
                value: values.language || 'en',
                label: findFullName(values.language, languages) || 'English'
            },
            flagIcon: values.country
        })
    )

    closeModal()
    window.location.href = newURL.toString()
}
